import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterEvent } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'main-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public appVersion: string;
  private login$: Subscription;
  public isLogin: boolean;
  private name$: Subscription;
  public name: string;

  ngOnInit() {
    this.appVersion = '0.0.0.0';
  }

  signOut() {
    location.reload();
  }

}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/layout/header/header.component.ts